import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    Button,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    IconButton,
    TableContainer,
    Tooltip,
    Menu,
    MenuItem,
    Select,
    InputBase,
    Pagination,
    CircularProgress,
} from '@mui/material';
import { Edit, Delete, MoreVert } from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import apiUrl from '../../Config';

const DisplayCombos = () => {
    const navigate = useNavigate();
    const [combos, setCombos] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedCombo, setSelectedCombo] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("")

    const open = Boolean(anchorEl);

    const handleMenuClick = (event, combo) => {
        setAnchorEl(event.currentTarget);
        setSelectedCombo(combo);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedCombo(null);
    };

    const getAllCombos = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${apiUrl}/combooffers/getallcombooffer?page=${page}&limit=${limit}&searchTerm=${searchTerm}`
            );
            const data = response.data;
            console.log(data, "data")

            setCombos(data.comboOffers);
            setTotalPages(data.totalPages || 1);
            setTotalItems(data.totalItems || 0);
        } catch (error) {
            console.log('Error fetching combo offers:', error);
            const message = error?.response?.data?.message || error.message || 'Failed to fetch testimonials'
            setError(message)
        } finally {
            setLoading(false);
        }
    };

    console.log(combos, "Combos")

    const handleDelete = async (id) => {
        try {
            await axios.delete(`${apiUrl}/combooffers/deletecombooffer/${id}`);
            getAllCombos();
            handleMenuClose();
        } catch (error) {
            console.error('Delete error:', error);
        }
    };

    useEffect(() => {
        getAllCombos();
    }, [page, limit]);

    const handleSearch = () => {
        setPage(1);
        getAllCombos();
    };

    return (
        <Box p={2}>
            <Typography variant="h4" my={2.5}>
                Combo Offers List
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 3,
                    gap: 2,
                }}
            >
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <InputBase
                        placeholder="Search Combo"
                        sx={{
                            border: '1px solid #ccc',
                            px: 2,
                            py: 0.5,
                            borderRadius: 1,
                            width: { xs: '220px', md: 300 },
                        }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <Button variant="outlined" onClick={handleSearch}>
                        Search
                    </Button>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography variant="body2">Rows per page:</Typography>
                    <Select
                        size="small"
                        value={limit}
                        onChange={(e) => {
                            setLimit(Number(e.target.value));
                            setPage(1);
                        }}
                    >
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                    </Select>

                    <Button variant="contained" onClick={() => navigate('/create-edit-combos')}>
                        Add Combo
                    </Button>
                </Box>
            </Box>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <TableContainer component={Paper} sx={{ width: '100%', overflowX: 'auto' }}>
                        <Table sx={{ minWidth: 800 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Image</TableCell>
                                    <TableCell>Title</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Price</TableCell>
                                    <TableCell>Discount</TableCell>
                                    <TableCell>Avaliable</TableCell>
                                    <TableCell align="right">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {combos.map((combo) => (
                                    <TableRow key={combo.id}>
                                        <TableCell>
                                            <img
                                                src={combo.imageUrl}
                                                alt="thumbnail"
                                                width={40}
                                                height={40}
                                                style={{ objectFit: 'cover', borderRadius: 4 }}
                                            />
                                        </TableCell>
                                        <TableCell>{combo.title}</TableCell>
                                        <TableCell>{combo.description}</TableCell>
                                        <TableCell>₹{combo.price}</TableCell>
                                        <TableCell>{combo.discountOffer || 0}%</TableCell>
                                        <TableCell>{combo.isActive === true ? "Avaliable" : "Not Avaliable"}</TableCell>
                                        <TableCell align="right">
                                            <IconButton onClick={(e) => handleMenuClick(e, combo)}>
                                                <MoreVert />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {combos.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center">
                                            No combos found.
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box mt={3} display="flex" justifyContent="center">
                        <Pagination
                            count={totalPages}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            showFirstButton
                            showLastButton
                            siblingCount={0}
                            boundaryCount={1}
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    height: 30,
                                    minWidth: 30,
                                    fontSize: '1rem',
                                    marginTop: '10px'
                                }
                            }}
                        />
                    </Box>

                    <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                        <MenuItem
                            onClick={() => {
                                navigate('/create-edit-combos', { state: { combo: selectedCombo } });
                                handleMenuClose();
                            }}
                        >
                            <Edit fontSize="small" sx={{ mr: 1 }} /> Edit
                        </MenuItem>
                        <MenuItem onClick={() => handleDelete(selectedCombo.id)}>
                            <Delete fontSize="small" sx={{ mr: 1 }} /> Delete
                        </MenuItem>
                    </Menu>
                </>
            )}

            {error && (
                <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                    {error}
                </Typography>
            )}
        </Box>
    );
};

export default DisplayCombos;
